import { NP_MONTHS } from '../data/months';

export const formatDate = (date) => {
  if (!date) return "";

  return new Date(date).toLocaleString("en-US", {
    timeZone: "UTC",
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

export const formatDisplayDate = (dateString) => {
  const date = new Date(dateString);

  const day = date.getDate();

  const suffix =
    day === 1 || day === 21 || day === 31 ? "st" :
      day === 2 || day === 22 ? "nd" :
        day === 3 || day === 23 ? "rd" : "th";

  const month = date.toLocaleString("en-US", { month: "short" });
  const weekday = date.toLocaleString("en-US", { weekday: "short" });

  return `${day}${suffix} ${month}, ${weekday}`;
};

// export const formatDateYear = (dateString) => {
//   const date = new Date(dateString);

//   const day = date.getDate();

//   const suffix =
//     day % 10 === 1 && day !== 11
//       ? "st"
//       : day % 10 === 2 && day !== 12
//         ? "nd"
//         : day % 10 === 3 && day !== 13
//           ? "rd"
//           : "th";

//   const month = date.toLocaleString("default", {
//     month: "long",
//   });

//   const year = date.getFullYear();

//   return `${day}${suffix} ${month}, ${year}`;
// };

// export const formatNepaliDateYear = (date) => {
//   if (!date) return "";

//   const [year, month, day] = date.split("-");

//   const suffix = (d) => {
//     if (d >= 11 && d <= 13) return "th";

//     switch (d % 10) {
//       case 1:
//         return "st";
//       case 2:
//         return "nd";
//       case 3:
//         return "rd";
//       default:
//         return "th";
//     }
//   };

//   const dayNum = Number(day);

//   return `${dayNum}${suffix(dayNum)} ${NP_MONTHS[Number(month) - 1]}, ${year}`;
// };

export const formatDateYear = (dateString) => {
  const date = new Date(dateString);

  const day = date.getDate();

  const month = date.toLocaleString("default", {
    month: "long",
  });

  const year = date.getFullYear();

  return `${month} ${day}, ${year}`;
};

export const formatNepaliDateYear = (date) => {
  if (!date) return "";

  const [year, month, day] = date.split("-");

  const dayNum = Number(day);

  return `${NP_MONTHS[Number(month) - 1]} ${dayNum}, ${year}`;
};

export const formatToISODate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};